module.exports = __webpack_public_path__ + "res/15-img_game_bg.4ececaa0b2a7ea02435b432e70be4552.png";